import { ref } from '@vue/composition-api'
import pagesApi from '@/services/api/pages'
import useFormAlert from '@/composables/useFormAlert'

export default function useTermsPage() {
  const pageText = ref('')
  const title = ref('')
  const loading = ref(false)
  const saving = ref(false)
  const alert = useFormAlert()

  async function fetchPage() {
    loading.value = true
    try {
      const res = await pagesApi.getPage('termsAndConditions')
      const page = res.data.data
      title.value = page.title != null ? page.title : 'ACA Terms & Conditions'
      pageText.value = page.page_text != null ? page.page_text : ''
    } finally {
      loading.value = false
    }
  }

  async function savePage() {
    saving.value = true
    try {
      const res = await pagesApi.updatePage('termsAndConditions', { page_text: pageText.value })
      const page = res.data.data
      pageText.value = page.page_text != null ? page.page_text : ''
      alert.showSuccess(res.data.message)
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      alert.showError(data != null ? data.message : null)
    } finally {
      saving.value = false
    }
  }

  return { pageText, title, loading, saving, alert, fetchPage, savePage }
}



// WEBPACK FOOTER //
// ./src/composables/pages/useTermsPage.js